import { Box, Typography } from "@dealer-center/core-components";

export const PagesNrtProviderConfigToolUiDisplay = () => {
  return (
    <Box>
      <Typography variant={"h1"}>Provider Configuration Tool</Typography>
    </Box>
  );
};
